module.exports = __webpack_public_path__ + "img/ico2.104e4611.png";